import { createRef } from 'react';
import { BottomSheetFragmentContainerRef } from '../components/dialogs/BottomSheetContainer';

export const bottomSheetfragmentContainerRef = createRef<BottomSheetFragmentContainerRef>();
